define('module/share',[
    'cnf',
    'underscore',
    'jquery'
], function(Cnf, _, $) {
    'use strict';
    
    return function()
    {
        this.options={
            timeout:1,
            selector:{
                trigger:'.trigger-share',
                holder:'.share-parent',
                teaser:'.teaser'
            },
            data:{
                active:'active',
                timeout:'timeout'
            }
        };
        
        this.init=function()
        {
            this.initOption();
            this.initEvent();
            this.initElement();
        };
        
        this.initOption=function()
        {
            this.$trigger=Cnf.$app.find(this.options.selector.trigger);
            this.iTrigger=this.$trigger.length;
        };
        
        this.initEvent=function()
        {
            
        };
        
        this.initElement=function()
        {
            if(this.iTrigger>0) {
                this.$trigger.on(Cnf.click, _.bind(this.show,this));
            }
        };
        
        this.show=function(ev)
        {
            var $this=$(ev.currentTarget),
                    $holder=$this.closest(this.options.selector.holder),
                    $teaser=$this.closest(this.options.selector.teaser);
            
            $holder.attr('data-' + this.options.data.active, 'true');
            
            if(false===Cnf.isTouch) {
                $teaser.on('mouseleave.social', _.bind(this.triggerHide, this, {$teaser:$teaser, $holder:$holder}));
                $teaser.on('mouseenter.social', _.bind(this.pauseHide, this, {$holder:$holder}));
            }
        };
        
        this.triggerHide=function(arg)
        {
            var iTimeout=window.setTimeout(_.bind(function(arg){
                arg.$teaser.off('mouseleave.social mouseenter.social');
                this.hide(arg.$holder);
            }, this, arg), (this.options.timeout *1000));
            
            arg.$holder.data(this.options.data.timeout, iTimeout);
        };
        
        this.pauseHide=function(arg)
        {
            window.clearTimeout(arg.$holder.data(this.options.data.timeout));
        };
        
        this.hide=function($el)
        {
            $el.attr('data-' + this.options.data.active, 'false');
        };
        
        this.init();
    };
});
